var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { chatApi } from '../chat/chat-api';
import { setChatApiStatus, setChatMachineStatus } from '../common/commonSlice';
import { chatMachineApi } from './chat-machine-api';
export var MachineStatus = function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var chatMachineToken, MACHINE_ENDPOINT, machineState, apiState, MAX_RETRIES, showErrorMessage, fetchMachineState, fetchApiState, retries;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chatMachineToken = dispatch(function (_, getState) { return getState().auth.chatMachineToken; });
                MACHINE_ENDPOINT = process.env.REACT_APP_CHAT_MACHINE_ENDPOINT;
                if (!(MACHINE_ENDPOINT && chatMachineToken && chatMachineToken !== null)) return [3 /*break*/, 21];
                machineState = void 0;
                apiState = void 0;
                MAX_RETRIES = 50;
                showErrorMessage = function () {
                    dispatch(setChatMachineStatus('error'));
                    dispatch(setChatApiStatus('error'));
                    throw new Error('Failed to boot AI Engine. Please refresh the page to retry.');
                };
                fetchMachineState = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, dispatch(chatMachineApi.endpoints.getMachineStatus.initiate(undefined, { forceRefetch: true }))];
                            case 1:
                                result = _a.sent();
                                return [2 /*return*/, result.data];
                        }
                    });
                }); };
                fetchApiState = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                dispatch(chatApi.util.invalidateTags(['ChatApiStatus']));
                                return [4 /*yield*/, dispatch(chatApi.endpoints.getHealth.initiate(undefined, { forceRefetch: true }))];
                            case 1:
                                result = _b.sent();
                                if (result.isError) {
                                    return [2 /*return*/, 'off'];
                                }
                                if (result.data) {
                                    return [2 /*return*/, (_a = result.data) === null || _a === void 0 ? void 0 : _a.status];
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                return [4 /*yield*/, fetchMachineState()];
            case 1:
                machineState = _a.sent();
                retries = 0;
                _a.label = 2;
            case 2:
                if (!(machineState === 'starting' || machineState === 'stopping')) return [3 /*break*/, 7];
                if (!(retries++ >= MAX_RETRIES)) return [3 /*break*/, 3];
                showErrorMessage();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2000); })];
            case 4:
                _a.sent();
                return [4 /*yield*/, fetchMachineState()];
            case 5:
                machineState = _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 2];
            case 7:
                if (!(machineState !== 'ready')) return [3 /*break*/, 14];
                return [4 /*yield*/, dispatch(chatMachineApi.endpoints.startMachine.initiate())];
            case 8:
                _a.sent();
                retries = 0;
                _a.label = 9;
            case 9:
                if (!(machineState !== 'ready')) return [3 /*break*/, 14];
                if (!(retries++ >= MAX_RETRIES)) return [3 /*break*/, 10];
                showErrorMessage();
                return [3 /*break*/, 13];
            case 10: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
            case 11:
                _a.sent();
                return [4 /*yield*/, fetchMachineState()];
            case 12:
                machineState = _a.sent();
                _a.label = 13;
            case 13: return [3 /*break*/, 9];
            case 14: return [4 /*yield*/, fetchApiState()];
            case 15:
                apiState = _a.sent();
                retries = 0;
                _a.label = 16;
            case 16:
                if (!(apiState !== 'ok')) return [3 /*break*/, 21];
                if (!(retries++ >= MAX_RETRIES)) return [3 /*break*/, 17];
                showErrorMessage();
                return [3 /*break*/, 20];
            case 17: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
            case 18:
                _a.sent();
                return [4 /*yield*/, fetchApiState()];
            case 19:
                apiState = _a.sent();
                _a.label = 20;
            case 20: return [3 /*break*/, 16];
            case 21: return [2 /*return*/];
        }
    });
}); };
